export default __webpack_public_path__ + "static/media/B_wdt_c_cap_1.8f880eaa.mp3";